import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getNewProducts } from '../../api/product/queries/getNewProducts';
import { INewProduct } from '../../interfaces/NewProduct.interfaces';

interface IUseGetNewProductsQueryParams {
  options?: UseQueryOptions<INewProduct[], AxiosError>;
}

/**
 * 새로운 상품 목록을 조회하는 useQuery 훅
 * @param options - React Query 옵션
 * @returns useQuery 결과
 */
export const useGetNewProductsQuery = ({ options }: IUseGetNewProductsQueryParams = {}) => {
  return useQuery<INewProduct[], AxiosError>(['new_products'], getNewProducts, options);
};
